import OcomQuoteList from "./pages/ListPage.vue";
import OcomQuoteDetail from "./pages/FormPage.vue";
import OcomQuoteIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/ocom_quote_old",
    component: OcomQuoteIndex,
    redirect: "/ocom_quote_old/list",
    name: "ocom_quote_old",
    children: [
      {
        path: "list",
        component: OcomQuoteList,
        name: "ocom_quote_old.list",
      },
      {
        path: "create",
        component: OcomQuoteDetail,
        name: "ocom_quote_old.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: OcomQuoteDetail,
        name: "ocom_quote_old.edit",
        props: { create: false },
      },
    ],
  },
];
